import React, {
    useCallback, useMemo, useContext
} from 'react';
import _ from 'lodash';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { ViewModelServiceContext, ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import classNames from 'classnames';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { withRouter } from 'react-router-dom';
import { TranslatorContext } from '@jutro/locale';
import { InputField, DropdownSelectField, InputNumberField } from '@jutro/legacy/components';
import { Icon } from '@jutro/components';
import { Link } from '@jutro/router';
import styles from './SurgicalCentreComponent.module.scss';
import metadata from './SurgicalCentreComponent.metadata.json5';

function SurgicalCentreComponent(props) {

    const {
        data: SurgicalCentreComponentVM,
        updateWizardData,
        submissionVM,
        SurgicalCentreComponentPath
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useContext(TranslatorContext);

    const addSurgicalCentre = useCallback(
        (event) => {
            if (event) {
                event.preventDefault();
            }

            SurgicalCentreComponentVM.value = SurgicalCentreComponentVM.value || []

            const { _xCenter, _dtoName } = SurgicalCentreComponentVM;

            const SurgicalCentreObjVM = viewModelService.create(
                {},
                _xCenter,
                _dtoName
            );

            SurgicalCentreObjVM.value.perOfRev2 = 0
            SurgicalCentreObjVM.value.annNumOfPro3 = 0

            SurgicalCentreComponentVM.pushElement(
                SurgicalCentreObjVM
            );
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, SurgicalCentreComponentVM, viewModelService]
    );


    const handleValueChange = useCallback(
        () => {
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData]
    );


    const removeAssignmentItem = useCallback(
        (event, index) => {
            if (event) {
                event.preventDefault();
            }

            SurgicalCentreComponentVM.value.splice(index, 1);
            _.set(submissionVM.value, SurgicalCentreComponentPath, SurgicalCentreComponentVM.value);
            updateWizardData(submissionVM);
        }, [submissionVM, updateWizardData, SurgicalCentreComponentPath, SurgicalCentreComponentVM.value]
    );


    const getTableCell = useCallback(
        // eslint-disable-next-line @typescript-eslint/no-shadow
        (item, index, props) => {
            const { path } = props;

            if (path === 'sur1') {
                const value = (item && item.sur1) ? item.sur1 : undefined;
                // eslint-disable-next-line security/detect-object-injection
                const availableValues = SurgicalCentreComponentVM.length > 0 && SurgicalCentreComponentVM.children[index].sur1
                    // eslint-disable-next-line security/detect-object-injection
                    ? SurgicalCentreComponentVM.children[index].sur1.aspects.availableValues
                        .map((typeCode) => ({
                            code: typeCode.code,
                            name: translator({
                                id: typeCode.name,
                                defaultMessage: typeCode.name
                            })
                        }))
                    : [];

                return (
                    <DropdownSelectField
                        id={index + path}
                        className={styles.coverageForm}
                        onValueChange={(val, changedPath) => {
                            item.sur1 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        dataType="string"
                        path={path}
                        value={value}
                        availableValues={availableValues}
                        searchable
                    />
                )
            }

            if (path === 'perOfRev2') {
                const value = item.perOfRev2;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.perOfRev2 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'annNumOfPro3') {
                const value = item.annNumOfPro3;

                return (
                    <InputNumberField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="number"
                        onValueChange={(val, changedPath) => {
                            item.annNumOfPro3 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }

            if (path === 'des4' && !_.isUndefined(item.sur1) && item.sur1 === 'Other') {
                const value = item.des4 ? item.des4 : '';

                return (
                    <InputField
                        id={index + path}
                        className={styles.tableColumn}
                        path={path}
                        dataType="String"
                        onValueChange={(val, changedPath) => {
                            item.des4 = val;
                            handleValueChange(val, changedPath, index);
                        }}
                        value={value}
                    />
                );
            }
        }, [handleValueChange, translator, SurgicalCentreComponentVM])

    const removeAssignmentTableRow = useCallback(
        (item, index) => (
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
                onClick={(e) => removeAssignmentItem(e, index, item)}
                className={classNames(styles.deleteSection, styles.deleteRow)}
            >
                <Icon icon="mi-delete" className={styles.deleteIcon} />
            </Link>
        ),
        [removeAssignmentItem]
    );

    const overrideProps = useMemo(() => ({
        '@field': {
            showOptional: false,
            showRequired: true
        },
        [`SurgicalCentreTable`]: {
            data: SurgicalCentreComponentVM.value,
        }

    }), [SurgicalCentreComponentVM.value])

    const resolvers = {
        resolveCallbackMap: {
            addSurgicalCentre,
            getTableCell,
            removeAssignmentTableRow
        }
    };

    const readValue = useCallback(
        (fieldId, fieldPath) => readViewModelValue(
            metadata.pageContent,
            SurgicalCentreComponentVM,
            fieldId,
            fieldPath,
            overrideProps
        ),
        [SurgicalCentreComponentVM, overrideProps]
    );

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={SurgicalCentreComponentVM}
            overrideProps={overrideProps}
            resolveValue={readValue}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

SurgicalCentreComponent.propTypes = wizardProps;
export default withRouter(SurgicalCentreComponent);
